
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 55 55","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.19 33.237l-1.915 7.147-6.998.148A27.377 27.377 0 010 27.5c0-4.56 1.109-8.86 3.075-12.647h.001l6.23 1.142 2.729 6.192a16.345 16.345 0 00-.883 5.313c0 2.019.366 3.953 1.037 5.737z","fill":"#FBBB00"}}),_c('path',{attrs:{"d":"M54.52 22.363c.315 1.663.48 3.381.48 5.137 0 1.969-.207 3.89-.601 5.742a27.494 27.494 0 01-9.683 15.703l-.001-.001-7.847-.4-1.11-6.933a16.39 16.39 0 007.052-8.37H28.105V22.364H54.52z","fill":"#518EF8"}}),_c('path',{attrs:{"d":"M44.715 48.944l.001.002A27.384 27.384 0 0127.5 55C17.027 55 7.922 49.147 3.277 40.532l8.912-7.295c2.322 6.198 8.302 10.61 15.311 10.61a16.26 16.26 0 008.258-2.236l8.957 7.333z","fill":"#28B446"}}),_c('path',{attrs:{"d":"M45.053 6.331l-8.909 7.293a16.256 16.256 0 00-8.644-2.472c-7.168 0-13.259 4.615-15.465 11.035l-8.959-7.334h-.001C7.652 6.029 16.872 0 27.5 0c6.672 0 12.79 2.377 17.553 6.331z","fill":"#F14336"}})])
          )
        }
      }
    